module.exports = __webpack_public_path__ + "img/blueGroup.0a0d487d.svg";